import { Component, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    Validators,
} from '@angular/forms';
import { Router } from '@angular/router';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MessageService } from 'primeng/api';
import { JwtToken } from 'src/app/core/models/token.model';
import { TokenService } from 'src/app/core/services/token.service';

import { UserService } from 'src/app/core/services/user.service';

import {
    ZtButtonConfig,
    ZtButtonType,
} from 'src/app/shared/components/atoms/zt-button/zt-button.model';
import { ZtIcon } from 'src/app/shared/components/atoms/zt-icon/zt-icon.model';
import { ZtTextInputConfig } from 'src/app/shared/components/atoms/zt-textinput/zt-textinput.model';
import { ZtLoaderService } from 'src/app/shared/components/molecules/zt-loader/zt-loader.service';

@UntilDestroy()
@Component({
    selector: 'zt-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss'],
})
export class LoginComponent implements OnInit {
    emailFieldConfig: ZtTextInputConfig = {
        id: 'email',
        name: 'email',
        label: 'Email',
    };

    passwordFieldConfig: ZtTextInputConfig = {
        id: 'password',
        name: 'password',
        label: 'Password',
        type: 'password',
    };

    loginBtnConfig: ZtButtonConfig = {
        id: 'login',
        name: 'login',
        icon: ZtIcon.ARROW_RIGHT,
        label: 'Login',
    };

    loginForm = new FormGroup({
        email: new FormControl<string>('', [
            Validators.required,
            Validators.email,
        ]),
        password: new FormControl<string>('', Validators.required),
    });

    constructor(
        private userService: UserService,
        private loadingService: ZtLoaderService,
        private tokenService: TokenService,
        private messageService: MessageService,
        private router: Router
    ) {}

    ngOnInit() {}

    onSubmitHandler(event: Event) {
        event.preventDefault();
    }

    loginClickHandler(): void {
        if (this.loginForm.touched && this.loginForm.valid) {
            this.loadingService.showLoader();
            this.userService
                .login(
                    this.loginForm.value.email!,
                    this.passwordControl?.value!
                )
                .pipe(untilDestroyed(this))
                .subscribe({
                    next: (data: JwtToken) => {
                        this.tokenService.setToken(data);
                        this.router.navigate(['/']);
                        this.loadingService.hideLoader();
                    },
                    error: (error: Error) => {
                        this.messageService.add({
                            severity: 'error',
                            summary:
                                'Make sure that the user or password entered is correct.',
                        });
                        this.loadingService.hideLoader();
                    },
                });
        }
    }

    get ZtButtonType(): typeof ZtButtonType {
        return ZtButtonType;
    }

    get emailControl(): AbstractControl<string | null, string | null> | null {
        return this.loginForm.get('email');
    }

    get passwordControl(): AbstractControl<
        string | null,
        string | null
    > | null {
        return this.loginForm.get('password');
    }
}
